import { USER_TYPE } from '../../config/settings/constant'
import { REACT_APP_CAPTCHA_ENABLED, REACT_APP_CAPTCHA_SITE_KEY } from '../../config/settings/environment'

/**
 * Custom hook to get a reCaptcha token.
 */
const useReCaptcha = () => {
  const element = document.getElementById('recaptcha')

  const initializeReCaptcha = ({ authUserType }) => {
    if (
      REACT_APP_CAPTCHA_ENABLED !== 'true' ||
      authUserType === USER_TYPE.PROVIDER ||
      authUserType === USER_TYPE.SELLER ||
      authUserType !== USER_TYPE.PUBLIC ||
      element !== null
    ) {
      return
    }

    if (element === null) {
      const script = document.createElement('script')
      script.setAttribute('id', 'recaptcha')
      script.src = `https://www.google.com/recaptcha/api.js?render=${REACT_APP_CAPTCHA_SITE_KEY}`
      document.body.appendChild(script)
    }
  }

  const waitForRecaptcha = () => {
    return new Promise(resolve => {
      const checkRecaptcha = () => {
        if (window.grecaptcha?.execute) {
          resolve()
        } else {
          setTimeout(checkRecaptcha, 100)
        }
      }
      if (document.readyState === 'complete') {
        checkRecaptcha()
      } else {
        window.addEventListener('load', checkRecaptcha)
      }
    })
  }

  const executeReCaptcha = async ({ action }) => {
    await waitForRecaptcha()
    return await new Promise((resolve, reject) => {
      window.grecaptcha
        .execute(REACT_APP_CAPTCHA_SITE_KEY, { action })
        .then(token => {
          resolve(token)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  return { executeReCaptcha, initializeReCaptcha }
}

export default useReCaptcha
